/**
 * Google Cloud Vision OCR Helper
 */

// Use relative URL to work in both development and production
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * Convert image file to base64 data URL
 */
const imageToBase64 = (imageFile) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(imageFile);
  });
};

/**
 * Check if Google Cloud Vision is available/configured
 */
export const isGoogleVisionAvailable = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/ocr/google-vision/status`);
    const data = await response.json();
    return data.available && data.configured;
  } catch (error) {
    console.error('❌ Failed to check Google Cloud Vision status:', error);
    return false;
  }
};

/**
 * Extract text using Google Cloud Vision
 */
export const extractWithGoogleVision = async (imageFile, onProgress = null) => {
  try {
    if (onProgress) onProgress(0.1);

    // Convert image to base64
    const base64Image = await imageToBase64(imageFile);
    
    if (onProgress) onProgress(0.3);


    // Send to server for processing
    const response = await fetch(`${API_BASE_URL}/ocr/google-vision`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        image: base64Image
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Google Vision OCR failed');
    }

    if (onProgress) onProgress(0.8);

    const result = await response.json();
    
    
    if (onProgress) onProgress(1.0);

    return {
      text: result.text,
      detections: result.detections || []
    };
  } catch (error) {
    console.error('❌ Google Vision extraction error:', error);
    throw error;
  }
};
